import axios from "axios";

import { VITE_BASE_URL_ORION, VITE_TENANT_ORION } from "@/constants";

const axiosInstanceOrion = axios.create({
  baseURL: VITE_BASE_URL_ORION,
  headers: {
    "X-Tenant": VITE_TENANT_ORION,
  },
});

export default axiosInstanceOrion;
